
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/worksheets/[activitySlug]",
      function () {
        return require("private-next-pages/worksheets/[activitySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/worksheets/[activitySlug]"])
      });
    }
  